"use strict";

let benefitDesignAndCoverage = require("./care-insights/benefitDesignAndCoverage.json");
let demographics = require("./care-insights/demographics.json");
let goalsAndEndOfLifePlanning = require("./care-insights/goalsAndEndOfLifePlanning.json");
let knowledgeAndChoice = require("./care-insights/knowledgeAndChoice.json");
let patientFamilyCommunity = require("./care-insights/patientFamilyCommunity.json");
let providerAccess = require("./care-insights/providerAccess.json");

let hospitalizationsEDVisits = require("./clinical-insights/hospitalizationsEDVisits.json");
let medicationsAllergies = require("./clinical-insights/medicationsAllergies.json");
let painAndSymptom = require("./clinical-insights/painAndSymptom.json");
let pastMedicalHistory = require("./clinical-insights/pastMedicalHistory.json");
let physicalExam = require("./clinical-insights/physicalExam.json");
let reviewOfSystems = require("./clinical-insights/reviewOfSystems.json");
let treatmentPlan = require("./clinical-insights/treatmentPlan.json");
let vitals = require("./clinical-insights/vitals.json");

const { Actions } = require("../actions/index");

benefitDesignAndCoverage = mapActions(benefitDesignAndCoverage);
demographics = mapActions(demographics);
goalsAndEndOfLifePlanning = mapActions(goalsAndEndOfLifePlanning);
knowledgeAndChoice = mapActions(knowledgeAndChoice);
patientFamilyCommunity = mapActions(patientFamilyCommunity);
providerAccess = mapActions(providerAccess);
hospitalizationsEDVisits = mapActions(hospitalizationsEDVisits);
medicationsAllergies = mapActions(medicationsAllergies);
painAndSymptom = mapActions(painAndSymptom);
pastMedicalHistory = mapActions(pastMedicalHistory);
physicalExam = mapActions(physicalExam);
reviewOfSystems = mapActions(reviewOfSystems);
treatmentPlan = mapActions(treatmentPlan);
vitals = mapActions(vitals);

const keyedIssuesByDomain = {
  benefitDesignAndCoverage,
  demographics,
  goalsAndEndOfLifePlanning,
  knowledgeAndChoice,
  patientFamilyCommunity,
  providerAccess,
  hospitalizationsEDVisits,
  medicationsAllergies,
  painAndSymptom,
  pastMedicalHistory,
  physicalExam,
  reviewOfSystems,
  treatmentPlan,
  vitals
};

const issues = Object.assign(
  {},
  benefitDesignAndCoverage,
  demographics,
  goalsAndEndOfLifePlanning,
  knowledgeAndChoice,
  patientFamilyCommunity,
  providerAccess,
  hospitalizationsEDVisits,
  medicationsAllergies,
  painAndSymptom,
  pastMedicalHistory,
  physicalExam,
  reviewOfSystems,
  treatmentPlan,
  vitals
);

const issueIds = Object.keys(issues).sort();

//issues = mapActions(issues);

function mapActions(issues) {
  //need to add actions to issues.
  Object.keys(issues).forEach((issueId) => {
    issues[issueId].actions = issues[issueId].actions.map((issueAction) => {
      const newAction = Actions[issueAction.id];

      if (typeof newAction === "undefined") {
        console.error(issueAction);
      }

      if (
        newAction &&
        !newAction.description.startsWith(`${newAction.type}:`)
      ) {
        newAction.description = `${newAction.type}: ${newAction.description}`;
      }

      if (newAction && newAction.type === "Other") {
        newAction.description = "";
      }

      return Object.assign(issueAction, newAction);
    });
  });
  return issues;
}

module.exports.Issues = issues;
module.exports.keyedIssues = keyedIssuesByDomain;
module.exports.IssueIds = issueIds;

// module.exports.benefitDesignAndCoverage = benefitDesignAndCoverage;
// module.exports.demographics = demographics;
// module.exports.goalsAndEndOfLifePlanning = goalsAndEndOfLifePlanning;
// module.exports.knowledgeAndChoice = knowledgeAndChoice;
// module.exports.patientFamilyCommunity = patientFamilyCommunity;
// module.exports.providerAccess = providerAccess;
// module.exports.hospitalizationsEDVisits = hospitalizationsEDVisits;
// module.exports.medicationsAllergies = medicationsAllergies;
// module.exports.painAndSymptom = painAndSymptom;
// module.exports.pastMedicalHistory = pastMedicalHistory;
// module.exports.physicalExam = physicalExam;
// module.exports.reviewOfSystems = reviewOfSystems;
// module.exports.treatmentPlan = treatmentPlan;
